import React from 'react';

function UsersIcon({ size = 16 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 17"
    >
      <g clipPath="url(#clip0_4236_2355)">
        <path
          fill="#000"
          d="M5 9.493a3 3 0 110-6 3 3 0 010 6zm0-4.667A1.667 1.667 0 105 8.16a1.667 1.667 0 000-3.333zm5 11.334v-.334a5 5 0 10-10 0v.334a.667.667 0 101.333 0v-.334a3.667 3.667 0 017.334 0v.334a.667.667 0 101.333 0zm6-3.334a4.666 4.666 0 00-7.778-3.478.667.667 0 10.89.993 3.333 3.333 0 015.555 2.485.667.667 0 101.333 0zm-4.333-6a3 3 0 110-6 3 3 0 010 6zm0-4.666a1.667 1.667 0 100 3.333 1.667 1.667 0 000-3.333z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4236_2355">
          <path fill="#fff" d="M0 0H16V16H0z" transform="translate(0 .826)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default UsersIcon;
